import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiHistorySystem {
    getHistorySystem = () => {
        return axiosClient.get(API_MAP.GET_HISTORY_SYSTEM)
    }
    updateHistorySystem = (data) => {
        return axiosClient.post(API_MAP.UPDATE_HISTORY_SYSTEM, data)
    }
    getListHistoryLogin = (param) => {
        return axiosClient.get(API_MAP.GET_HISTORY_LOGIN,{params:param})
    }
    getMyHistoryLogin = (param) => {
        return axiosClient.get(API_MAP.GET_MY_HISTORY_LOGIN,{params:param})
    }
    getListHistoryAction = (param) => {
        return axiosClient.get(API_MAP.GET_HISTORY_ACTION,{params:param})
    }
    getListErrorLog = (param) => {
        return axiosClient.get(API_MAP.GET_ERROR_LOG,{params:param})
    }
    getUpdate2FA = (param) => {
        return axiosClient.get(API_MAP.HISTORY.UPDATE_2FA,{params:param})
    }
    getUpdateDetail2FA = (useId, param) => {
        return axiosClient.get(API_MAP.HISTORY.UPDATE_DETAIL_2FA(useId) ,{params:param})
    }
}

const apiHistorySystem = new ApiHistorySystem();

export default apiHistorySystem;